export const TIERS = ["basic", "pro", "team"] as const;
